export * from '@fhs/routing/src/routes/(tabs)/_layout.web';
export { default } from '@fhs/routing/src/routes/(tabs)/_layout.web';
